<template>
  <img
    :src="iconSrc"
    alt=""
    class="phone-task-type-icon"
    width="24"
    height="24"
    data-testid="phone-task-type-icon"
  />
</template>

<script setup>
import { computed } from "vue";
import { PHONE_TASK_KIND } from "@/utils/phoneTasks";

const props = defineProps({
  kind: {
    type: String,
    default: PHONE_TASK_KIND.SIMPLE,
  },
});

const uploadCloud = require("@components/assets/upload-cloud-02.svg");
const qrCode = require("@components/assets/qr-code-01.svg");
const checkSquare = require("@components/assets/check-square.svg");

const asUrl = (asset) => (typeof asset === "string" ? asset : asset?.default || "");

const iconSrc = computed(() => {
  if (props.kind === PHONE_TASK_KIND.UPLOAD) return asUrl(uploadCloud);
  if (props.kind === PHONE_TASK_KIND.QR) return asUrl(qrCode);
  return asUrl(checkSquare);
});
</script>

<style scoped>
.phone-task-type-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}
</style>
